// Mock data for Future Smarter Lighting - Smart Home Lighting Automation

export const navLinks = [
  { name: 'Home', href: '#home' },
  { name: 'About Us', href: '#about' },
  { name: 'How It Works', href: '#how-it-works' },
  { name: 'Solutions', href: '#solutions' },
  { name: 'Features', href: '#features' },
  { name: 'Projects', href: '#projects' },
  { name: 'Testimonials', href: '#testimonials' },
  { name: 'FAQs', href: '#faqs' },
  { name: 'Contact Us', href: '#contact' },
];

export const offerings = [
  {
    icon: 'Lightbulb',
    title: 'Smart Lighting Automation',
    description: 'Control your lights from anywhere, anytime.',
  },
  {
    icon: 'Mic',
    title: 'Voice Control',
    description: 'Works seamlessly with Alexa and Siri.',
  },
  {
    icon: 'LayoutGrid',
    title: 'Scene Automation',
    description: 'Create the perfect ambience for every moment.',
  },
  {
    icon: 'CalendarClock',
    title: 'Scheduling',
    description: 'Automatic ON/OFF based on time or sunrise/sunset.',
  },
  {
    icon: 'Leaf',
    title: 'Energy Efficiency',
    description: 'Reduce unnecessary power consumption and save more.',
  },
  {
    icon: 'Smartphone',
    title: 'Remote Access',
    description: 'Control your home lighting while you\'re away.',
  },
];

export const howItWorksSteps = [
  {
    icon: 'Users',
    title: 'Consultation',
    description: 'We understand your needs and assess your home requirements.',
  },
  {
    icon: 'Wrench',
    title: 'Installation',
    description: 'Our experts install the smart lighting system professionally.',
  },
  {
    icon: 'Smartphone',
    title: 'Smart Setup',
    description: 'We integrate with Alexa, Siri and mobile app for seamless control.',
  },
  {
    icon: 'Home',
    title: 'Enjoy Automation',
    description: 'Experience the comfort of automated lighting at your command.',
  },
];

export const smartScenes = [
  {
    name: 'Movie Night',
    image: 'https://images.unsplash.com/photo-1750994700146-36cd96c68bdc?w=800&q=80',
  },
  {
    name: 'Dinner Mode',
    image: 'https://images.unsplash.com/photo-1706820229870-f9a8c6dac193?w=800&q=80',
  },
  {
    name: 'Party Mode',
    image: 'https://images.pexels.com/photos/31374154/pexels-photo-31374154.jpeg?w=800&q=80',
  },
  {
    name: 'Good Night',
    image: 'https://images.unsplash.com/photo-1552858725-2758b5fb1286?w=800&q=80',
  },
];

export const roomLevels = [
  { name: 'Living Room', level: 100 },
  { name: 'Bedroom', level: 80 },
  { name: 'Kitchen', level: 60 },
  { name: 'Dining Room', level: 40 },
];

export const comparison = {
  before: [
    'Manual switches',
    'No scheduling',
    'No voice control',
    'No remote access',
    'Higher energy usage',
  ],
  after: [
    'Voice control',
    'Automated schedules',
    'Custom scenes',
    'Remote access',
    'Energy efficient',
  ],
};

export const projects = [
  {
    title: 'Loxury Villa — Living Room',
    image: 'https://images.unsplash.com/photo-1564078516393-cf04bd966897?w=800&q=80',
  },
  {
    title: 'Modern Apartment',
    image: 'https://images.unsplash.com/photo-1708113388262-17fdf0e21205?w=800&q=80',
  },
  {
    title: 'Home Theater',
    image: 'https://images.unsplash.com/photo-1750994700146-36cd96c68bdc?w=800&q=80',
  },
  {
    title: 'Master Bedroom',
    image: 'https://images.pexels.com/photos/6580373/pexels-photo-6580373.jpeg?w=800&q=80',
  },
  {
    title: 'Dining Area',
    image: 'https://images.pexels.com/photos/31374154/pexels-photo-31374154.jpeg?w=800&q=80',
  },
  {
    title: 'Penthouse Suite',
    image: 'https://images.unsplash.com/photo-1666585607888-3f6fe0b323d8?w=800&q=80',
  },
  {
    title: 'Premium Lounge',
    image: 'https://images.pexels.com/photos/19473771/pexels-photo-19473771.jpeg?w=800&q=80',
  },
  {
    title: 'Designer Kitchen',
    image: 'https://images.pexels.com/photos/34989208/pexels-photo-34989208.jpeg?w=800&q=80',
  },
];

export const testimonials = [];

export const solutions = [
  {
    title: 'Residential Full-Home',
    badge: 'Most Popular',
    image: 'https://images.unsplash.com/photo-1564078516393-cf04bd966897?w=1200&q=85',
    features: [
      'Whole-home zone control',
      'Scene presets & scheduling',
      'Voice & app integration',
      'Energy usage dashboard',
    ],
  },
  {
    title: 'Apartment Starter Pack',
    badge: 'Best Value',
    image: 'https://images.unsplash.com/photo-1560257084-d568f6eb7b29?w=1200&q=85',
    features: [
      'Up to 6 lighting zones',
      'Mobile app control',
      '2 preset scenes',
      '1 year warranty',
    ],
  },
  {
    title: 'Premium Smart Villa',
    badge: 'Full Luxury',
    image: 'https://images.unsplash.com/photo-1666585607888-3f6fe0b323d8?w=1200&q=85',
    features: [
      'Unlimited zones',
      'Circadian rhythm lighting',
      'Full BMS integration',
      'Lifetime support',
    ],
  },
];

export const faqs = [
  {
    q: 'What is smart home lighting automation?',
    a: 'Smart home lighting automation lets you control your lights using voice commands, mobile apps, schedules, and scenes — making your home more convenient, energy-efficient, and stylish.',
  },
  {
    q: 'Do your systems work with Alexa and Siri?',
    a: 'Yes! Our solutions integrate seamlessly with both Amazon Alexa and Apple Siri (HomeKit), letting you control lighting hands-free.',
  },
  {
    q: 'How long does installation take?',
    a: 'Most home installations are completed in 1–3 days depending on the size of the home and complexity of automation.',
  },
  {
    q: 'Will I need to rewire my entire home?',
    a: 'Not necessarily. Our smart systems are designed to retrofit into existing wiring in most cases, minimizing disruption.',
  },
  {
    q: 'Do you provide after-sales support?',
    a: 'Absolutely. We provide dedicated after-sales support, regular maintenance options, and warranty coverage on all installations.',
  },
  {
    q: 'Is smart lighting energy efficient?',
    a: 'Yes. With scheduling, motion sensing, and LED technology, smart lighting typically reduces lighting energy consumption by 30–60%.',
  },
];

export const contactInfo = {
  phone: '+91 98459 29347',
  whatsapp: '919845929347',
  whatsappMsg: "Hi, I'm interested in your services.",
  email: 'hello@futuresmarterlighting.in',
  address: '1, Rajamma Building, 22nd Cross, Kilari Rd, Bengaluru, Karnataka 560053, India',
  googleReviews: { rating: 5.0, count: 2 },
};
